export default { sha: '40c3178b6a18fe144708bedb108336e4cd74800b', buildNumber: 'undefined' }
